'use client';

import Link from 'next/link';
import { Check } from 'lucide-react';
import { pricingTiers, oneSentenceBill, guaranteeStrip } from '@/lib/pricing-display';

export default function PricingPreviewSection() {
  return (
    <section id="pricing" className="py-20 scroll-mt-20">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-13">
          <div className="landing-section-label">Simple pricing</div>
          <h2 className="text-[38px] font-bold tracking-[-1.5px] mb-3.5 text-foreground">
            One seat for the builder. Everyone Tessa talks to is free.
          </h2>
          <p className="text-[16px] text-muted-foreground max-w-[640px] mx-auto leading-[1.7]">
            {oneSentenceBill}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-13">
          {pricingTiers.map((tier) => (
            <div
              key={tier.id}
              className={`bg-card border rounded-[16px] p-9 transition-all hover:-translate-y-1 hover:shadow-md relative flex flex-col ${
                tier.highlight
                  ? 'border-[#EF4444] shadow-[0_0_0_1px_#EF4444]'
                  : 'border-border'
              }`}
            >
              {tier.highlight && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#EF4444] text-white px-4 py-1 rounded-full text-[12px] font-semibold">
                  Popular
                </div>
              )}
              <div className="text-[18px] font-bold text-foreground mb-1">{tier.name}</div>
              <div className="mb-1">
                <span className="text-[42px] font-bold tracking-[-2px] text-foreground">{tier.price}</span>
              </div>
              <p className="text-[13px] text-muted-foreground mb-6">{tier.priceNote}</p>
              <ul className="space-y-2 mb-7 flex-1">
                {tier.bullets.map((bullet) => (
                  <li key={bullet} className="flex items-start gap-2 text-[14px] text-foreground">
                    <Check className="w-4 h-4 text-[#10B981] flex-shrink-0 mt-0.5" />
                    {bullet}
                  </li>
                ))}
              </ul>
              <Link
                href={tier.cta.href}
                className={`block w-full text-center py-3 rounded-full text-[14px] font-semibold transition-all ${
                  tier.highlight
                    ? 'bg-[#EF4444] text-white hover:bg-[#DC2626]'
                    : 'bg-card text-foreground border border-border hover:border-foreground'
                }`}
              >
                {tier.cta.label}
              </Link>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
          {guaranteeStrip.map((item) => (
            <div
              key={item}
              className="flex items-start gap-2.5 bg-muted/50 border border-border rounded-[12px] p-4"
            >
              <Check className="w-4 h-4 text-[#10B981] flex-shrink-0 mt-0.5" />
              <span className="text-[13px] text-muted-foreground leading-[1.6]">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
